import axios from "axios";

export const fetchAllPresets = (wid) => {
    return dispatch => {
        dispatch({type:"PRESETS_ACTION_START"})
        const auth = localStorage.getItem("auth_token");
        const headers = { "x-auth-token": auth };
        axios.get(`/api/v1/presets/list-presets`, { headers })
            .then((result) => {
                dispatch({
                    type: "PRESETS_FETCH_DATA",
                    payload: result?.data?.project || result?.data?.presets_list || result?.data?.presets || result?.data?.preset_list || result?.data?.data || (Array.isArray(result?.data) ? result?.data : [])
                }) 
            }).catch((error) => {
                dispatch({
                    type: "PRESETS_FETCH_DATA_FAILED",
                    payload: error?.response?.data?.error || error?.message || "Failed to fetch presets"
                }) 
            });
    }
}
